import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";
import { getAuth, signOut } from "firebase/auth";
import Layout from "../components/Layout";
import { useState, useEffect } from "react";
import axios from "axios";
import api from "../api";

const Dashboard = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(getAuth());
    localStorage.clear();
    navigate("/login");
  };

  const [stats, setStats] = useState({
    users: 0,
    businesses: 0,
    freelancers: 0,
    admins: 0
  });

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const res = await api.get("/admin-management/stats");
      setStats(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout>
      <div className="cards">
        <div className="card-box">
          <h3>Users</h3>
          <p>{stats.users}</p>
        </div>

        <div className="card-box">
          <h3>Businesses</h3>
          <p>{stats.businesses}</p>
        </div>

        <div className="card-box">
          <h3>Freelancers</h3>
          <p>{stats.freelancers}</p>
        </div>

        <div className="card-box">
          <h3>Admins</h3>
          <p>{stats.admins}</p>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;